import { Binary, Radio } from 'lucide-react';

import { SignalType } from '../types';

export function renderSignalTypeIcon(signalType: SignalType | null | undefined, title: string) {
  if (!signalType) {
    return <span className="text-gray-light">-</span>;
  }

  const { IconComponent, color } =
    signalType.toLowerCase() === SignalType.DIGITAL
      ? { IconComponent: Binary, color: 'text-accent' }
      : { IconComponent: Radio, color: 'text-success' };

  return (
    <span className="text-xs text-gray">
      <div className="flex items-center justify-center" title={title}>
        <IconComponent className={`h-4 w-4 ${color}`} />
      </div>
    </span>
  );
}
